var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoveItCircle = function SvgLoveItCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.555 5.348A8 8 0 0 1 12 4a8.009 8.009 0 0 1 8 8A8 8 0 1 1 7.555 5.348zm.741 12.195A6.666 6.666 0 0 0 12 18.667 6.674 6.674 0 0 0 18.667 12a6.667 6.667 0 1 0-10.37 5.543zm4.964-8.765a2.33 2.33 0 0 1 1.1-.08 2.324 2.324 0 0 1 1.725 1.268 2.348 2.348 0 0 1-.44 2.714l-3.404 3.55a.336.336 0 0 1-.371.076.334.334 0 0 1-.11-.075l-3.41-3.557a2.35 2.35 0 1 1 3.33-3.319l.32.322.321-.321a2.33 2.33 0 0 1 .94-.578z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoveItCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "love-it-circle.9c60b87d842d86d988609dbe4f798dc1.svg";